import { applyMiddleware, createStore, Store } from 'redux'; // good code
import createBrowserHistory from 'history/createBrowserHistory'; // good code
import { connectRouter, routerMiddleware } from 'connected-react-router'; // good code

import  rootReducer  from '../store/reducers/rootReducer';
// We'll be using Redux Devtools. We can use the `composeWithDevTools()`
// directive so we can pass our middleware along with it
import { composeWithDevTools } from 'redux-devtools-extension';
import  thunk  from 'redux-thunk'


export const history = createBrowserHistory();

export default function configureStore(initialState: any): Store<any> {
    const composeEnhancers = composeWithDevTools({
        // Specify name here, actionsBlacklist, actionsCreators and other options if needed
    });

    
    const store = createStore(
        connectRouter(history)(rootReducer), // good code
        initialState,
        composeEnhancers(applyMiddleware(thunk))
    );

    // start up the sagas listeners
    //sagaMiddleware.run(rootSaga);

    return store;
}


// WEBPACK FOOTER //
// ./src/store/store.ts